import React, { useCallback } from "react";
import { Select } from "antd";
import { CompanyStatus, CompanyStatusMap } from "@/utils/enum";
import { statusToColor } from "./enums";

const { Option } = Select;

function EntityFlagToggle({ style, currentStatus, showUpdateEntityFlagModal, disabled }) {
  const handleSelectOption = useCallback(
    status => {
      showUpdateEntityFlagModal(status);
    },
    [showUpdateEntityFlagModal],
  );

  if (disabled) {
    const status = +currentStatus || "";
    return (
      <div style={{ marginTop: "12px" }}>
        <span
          style={{
            color: statusToColor[status],
            fontWeight: "bold",
            border: "1px solid rgb(217, 217, 217)",
            borderRadius: "10px",
            padding: "4px 40px",
            ...style,
          }}
        >
          {CompanyStatusMap[status]}
        </span>
      </div>
    );
  }

  return (
    <Select
      style={style}
      value={+currentStatus || ""}
      onChange={value => handleSelectOption(value)}
      onClick={e => e.stopPropagation()}
    >
      {Object.values(CompanyStatus).map(status => (
        <Option key={status} value={status}>
          <span style={{ color: statusToColor[status] }}>{CompanyStatusMap[status]}</span>
        </Option>
      ))}
    </Select>
  );
}

export default EntityFlagToggle;
